import React from "react";

const formatBinWrPercent = (value) => {
  if (value === null || value === undefined) return "0.0%";
  const numValue = typeof value === "string" ? parseFloat(value) : value;
  if (isNaN(numValue)) return "0.0%";
  return `${(numValue * 100).toFixed(1)}%`;
};

const BinsTable = ({ binData }) => {
  if (!binData || !binData.length)
    return <div className="text-gray-500">No bin data available.</div>;
  return (
    <div className="overflow-x-auto mt-2">
      <table className="table-auto min-w-full border border-gray-300 text-xs md:text-sm">
        <thead className="bg-gray-100">
          <tr>
            <th className="border px-2 py-1 text-center">Bin</th>
            <th className="border px-2 py-1 text-center">Number</th>
            <th className="border px-2 py-1 text-center">Culled</th>
            <th className="border px-2 py-1 text-center">Released</th>
            <th className="border px-2 py-1 text-center">Average Wr</th>
            <th className="border px-2 py-1 text-center">Stdev Wr</th>
          </tr>
        </thead>
        <tbody>
          {binData.map((bin, idx) => (
            <tr key={idx}>
              <td className="border px-2 py-1 text-center font-semibold">
                {bin.binLabel}
              </td>
              <td className="border px-2 py-1 text-center">{bin.number}</td>
              <td className="border px-2 py-1 text-center">{bin.culled}</td>
              <td className="border px-2 py-1 text-center">{bin.released}</td>
              <td className="border px-2 py-1 text-center">
                {formatBinWrPercent(bin.averageWr)}
              </td>
              <td className="border px-2 py-1 text-center">
                {formatBinWrPercent(bin.stdev)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default BinsTable;
